import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from '../locales/en/common.json';
import enSidebar from '../locales/en/sidebar.json';
import enAuth from '../locales/en/auth.json';
import enDashboard from '../locales/en/dashboard.json';
import enPatients from '../locales/en/patients.json';
import enAppointments from '../locales/en/appointments.json';
import enRecords from '../locales/en/records.json';
import enBilling from '../locales/en/billing.json';
import enSettings from '../locales/en/settings.json';
import enValidation from '../locales/en/validation.json';
import enProfile from '../locales/en/profile.json';
import enPractice from '../locales/en/practice.json';

import frCommon from '../locales/fr/common.json';
import frSidebar from '../locales/fr/sidebar.json';
import frAuth from '../locales/fr/auth.json';
import frDashboard from '../locales/fr/dashboard.json';
import frPatients from '../locales/fr/patients.json';
import frAppointments from '../locales/fr/appointments.json';
import frRecords from '../locales/fr/records.json';
import frBilling from '../locales/fr/billing.json';
import frSettings from '../locales/fr/settings.json';
import frValidation from '../locales/fr/validation.json';
import frProfile from '../locales/fr/profile.json';
import frPractice from '../locales/fr/practice.json';

import arCommon from '../locales/ar/common.json';
import arSidebar from '../locales/ar/sidebar.json';
import arAuth from '../locales/ar/auth.json';
import arDashboard from '../locales/ar/dashboard.json';
import arPatients from '../locales/ar/patients.json';
import arAppointments from '../locales/ar/appointments.json';
import arRecords from '../locales/ar/records.json';
import arBilling from '../locales/ar/billing.json';
import arSettings from '../locales/ar/settings.json';
import arValidation from '../locales/ar/validation.json';
import arProfile from '../locales/ar/profile.json';
import arPractice from '../locales/ar/practice.json';

// Define resources
const resources = {
  en: {
    common: enCommon,
    sidebar: enSidebar,
    auth: enAuth,
    dashboard: enDashboard,
    patients: enPatients,
    appointments: enAppointments,
    records: enRecords,
    billing: enBilling,
    settings: enSettings,
    validation: enValidation,
    profile: enProfile,
    practice: enPractice
  },
  fr: {
    common: frCommon,
    sidebar: frSidebar,
    auth: frAuth,
    dashboard: frDashboard,
    patients: frPatients,
    appointments: frAppointments,
    records: frRecords,
    billing: frBilling,
    settings: frSettings,
    validation: frValidation,
    profile: frProfile,
    practice: frPractice
  },
  ar: {
    common: arCommon,
    sidebar: arSidebar,
    auth: arAuth,
    dashboard: arDashboard,
    patients: arPatients,
    appointments: arAppointments,
    records: arRecords,
    billing: arBilling,
    settings: arSettings,
    validation: arValidation,
    profile: arProfile,
    practice: arPractice
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'sidebar', 'auth', 'dashboard', 'patients', 'appointments', 'records', 'billing', 'settings', 'validation', 'profile', 'practice'],
    
    interpolation: {
      escapeValue: false // React already escapes values
    },

    detection: {
      // Detection order and caches
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'doctif_language'
    },

    react: {
      useSuspense: false
    }
  });

export default i18n;
